import useFormatter from "@/hooks/use-formatter.hook.ts";
import { ApiEmployee } from "@/types/employees/employee.types.ts";
import { Text } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

const variantClassMap = {
  primary: "text-title text-3xl font-medium font-headline lining-nums proportional-nums mb-5",
  secondary: "text-secondary text-lg",
};

interface TasksTodoCountTitleProps {
  count: number;
  variant: keyof typeof variantClassMap;
  employee?: ApiEmployee;
}

export function TasksTodoCountText({ count, variant, employee }: TasksTodoCountTitleProps) {
  const { t } = useTranslation();
  const { renderEmployeeName } = useFormatter();

  if (employee) {
    return (
      <Text className={variantClassMap[variant]}>
        {t("tasks:tasks_related_employee", {
          tasks: t("plurals:tasks_count", { count }),
          employee: renderEmployeeName(employee),
        })}
      </Text>
    );
  }

  return (
    <Text className={variantClassMap[variant]}>
      {count === 0 ? (
        t("tasks:title_todo_count_zero")
      ) : (
        <>
          {t("tasks:title_todo_count_prefix")}{" "}
          <Text
            className={
              variant === "primary" ? twMerge(variantClassMap[variant], "text-warning") : ""
            }
          >
            {count}
          </Text>{" "}
          {t("plurals:tasks_todo_count", { count })}
        </>
      )}
    </Text>
  );
}
